import React from 'react';
import CloakLoading from '../../../../components/CloakLoading';
import classes from './styles/index.module.scss';

export default () => {
	return (
		<div className={classes.headerClockLoading}>
			<CloakLoading size='small' />
		</div>
	);
};
